import { PropsWithChildren, ReactNode, useMemo } from 'react'
import { ValidatorFn, isRequire, validateField } from '../../../hooks/useForm'

import { InputGroup } from './InputGroup'

export interface ValidateControlProps {
  id: string
  title: string
  value?: any
  onChange?: any
  require?: boolean
  requireType?: 'star' | 'optional'
  validators?: ValidatorFn[]
  placeholder?: string
  firstSubmit?: boolean
  error?: string
  className?: string
  disabled?: boolean
  prefix?: string | ReactNode
}

export const ValidateControl = (props: ValidateControlProps) =>
  useMemo(() => <Control {...props} />, [
    props.value,
    props.require,
    props.firstSubmit,
    props.error,
    props.validators
  ])

function Control({
  id,
  className,
  title,
  placeholder,
  value,
  onChange,
  require,
  validators = [],
  firstSubmit,
  error = '',
  disabled = false,
  prefix
}: PropsWithChildren<ValidateControlProps>) {
  validators = require ? [isRequire(), ...validators] : validators
  error = firstSubmit ? validateField(value, title, validators) || error : error || ''
  const defaultEditor = (
    <input
      id={id}
      className={className}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
    />
  )

  return (
    <InputGroup prefix={prefix} errClassName={`${id}_err`} error={error}>
      {defaultEditor}
    </InputGroup>
  )
}
